import React from 'react';
import ACarousel from 'antd-mobile/lib/carousel';



export default class Carousel extends ACarousel {}
